import { cn } from '../../lib/utils';

/** Brand gradient ring spinner. */
export default function Spinner({ size = 24, className }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn('inline-block animate-spin rounded-full', className)}
      style={{
        width: size,
        height: size,
        borderWidth: Math.max(2, size / 10),
        borderStyle: 'solid',
        borderColor: 'rgb(109 94 252 / 0.25)',
        borderTopColor: 'rgb(109 94 252)',
      }}
    />
  );
}
